
const WebIcon = ({ name, className }) => (<span aria-hidden="true" className={`material-symbols-outlined ${className}`}>{name}</span>)

export default WebIcon